import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ApprovalsContainerComponent } from './components/approvals-container/approvals-container.component';

const routes: Routes = [
  {
    path: '',
    component: ApprovalsContainerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ApprovalsRoutingModule {}
